import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { PanelEmptyState } from './PanelEmptyState';
import { ProjectsEmptyIllustration } from './empty-illustration';

interface ProjectsEmptyStateProps {
  actions?: React.ReactNode;
}

export const ProjectsEmptyState: React.FC<ProjectsEmptyStateProps> = ({ actions }) => {
  const { t } = useLocale();

  return (
    <PanelEmptyState
      illustration={<ProjectsEmptyIllustration />}
      title={t('projects_empty_title')}
      description={t('projects_empty_description')}
      actions={actions}
    />
  );
};

export const TrashEmptyState: React.FC = () => {
  const { t } = useLocale();

  return (
    <PanelEmptyState
      illustration={<ProjectsEmptyIllustration />}
      title={t('no_trashed_projects')}
      description={t('trash_empty_description')}
    />
  );
};
